import AjaxService, { validateResponse } from '../services/ajax-service';

import { handleServerError } from 'shared-services/error-service';

export const fetchFolders = ({ projectId, type, folderId, offset, limit }) => {
    return AjaxService({
        method: 'get',
        url: 'folders',
        params: {
            project_id: projectId,
            folder_id: folderId,
            type,
            offset,
            limit
        }
    })
    // .then(response => response.data)
    .then(response => ({
        ...response.data,
        items: response.data.items.map(item => ({
            ...item,
            parent_folder: folderId
        }))
    }))
    .catch(handleServerError);
}

export const createFolder = ({ project_id, parent_folder, folder_stack, type, name }) => {
    return AjaxService({
        method: 'post',
        url: 'folders',
        data: {
            project_id,
            folder_name: name,
            parent_folder,
            type,
            folder_stack
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const fetchFolder = folderId => {
    return AjaxService({
        method: 'get',
        url: `folders/${folderId}`
    })
    .then(response => validateResponse(response, 'id').data)
    .catch(handleServerError);
}

export const updateFolder = (folderId, { project, name, parent_folder, folder_stack }) => {
    return AjaxService({
        method: 'put',
        url: `folders/${folderId}`,
        data: {
            project_id: project,
            name,
            parent_folder,
            folder_stack
        }
    })
    .then(response => response.data)
    .catch(handleServerError);
}

export const removeFolder = folderId => {
    return AjaxService({
        method: 'delete',
        url: `folders/${folderId}`
    })
    .then(response => response.data)
    .catch(handleServerError);
}
